export const EXTRA_TILE_CLASSES = {
    removeCircleIcon: 'aumico-pattern-icon-remove',
    resetIcon: 'aumico-pattern-icon-erase-icon',
    plusIcon: 'aumico-pattern-icon-plus',
    rowHeightBig: 'row-height-big',
    rowHeightSmall: 'row-height-small',
} as const;
